export enum CompanyTypeEnum {
  ADMIN = 'admin',
  VENDOR = 'vendor',
  RESTAURANT = 'restaurant'
}
